const MIN_PAGING_ITEM_COUNT = 7;
const FIRST_MORE_ITEM_INDEX = -1;
const LAST_MORE_ITEM_INDEX = -2;

const push = (array: number[], ...rest: (number | [number, number])[]): void => {
  for (const item of rest) {
    if (typeof item === 'number') {
      array.push(item);
    } else {
      for (let i = item[0]; i <= item[1]; i++) {
        array.push(i);
      }
    }
  }
};

export const listVisiblePages = (
  pageCount: number,
  currentPage: number,
  maxPages?: number,
): number[] => {
  const max = Math.max(maxPages || MIN_PAGING_ITEM_COUNT, MIN_PAGING_ITEM_COUNT);
  let prevCount = Math.floor((max - 1) / 2);
  let nextCount = max - prevCount - 1;
  if (currentPage + nextCount > pageCount - 1) {
    prevCount += currentPage + nextCount - pageCount + 1;
  }
  const result: number[] = [];
  if (currentPage <= prevCount) {
    push(result, [0, currentPage - 1]);
  } else {
    push(result, 0, FIRST_MORE_ITEM_INDEX, [currentPage - prevCount + 2, currentPage - 1]);
  }
  result.push(currentPage);
  nextCount = max - result.length;
  if (currentPage + nextCount >= pageCount - 1) {
    push(result, [currentPage + 1, pageCount - 1]);
  } else {
    push(
      result,
      [currentPage + 1, currentPage + nextCount - 2],
      LAST_MORE_ITEM_INDEX,
      pageCount - 1,
    );
  }
  return result;
};
